/* eslint-disable max-len */
import { RouteConfig } from 'vue-router';
import { metaRequireGuest } from '@/router/meta-constants';

const authenticateRoutes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'Login',
    meta: metaRequireGuest,
    component: () => import(/* webpackChunkName: "authenticate" */ '@/views/web/authenticate/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    meta: metaRequireGuest,
    component: () => import(/* webpackChunkName: "authenticate" */ '@/views/web/authenticate/Register.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    meta: metaRequireGuest,
    component: () => import(/* webpackChunkName: "authenticate" */ '@/views/web/authenticate/ForgotPassword.vue')
  }
];

export default authenticateRoutes;
